import React, { useEffect, useRef, useState } from "react";

// /px/preview is slow (STAC lookup + raster read per request) and the pixel
// server has a small worker pool, so loading every thumbnail at once starves
// later requests such as the Compare modal. Cap how many load concurrently.
const MAX_CONCURRENT_LOADS = 4;

let activeLoads = 0;
const waiting = [];

const startNext = () => {
  while (activeLoads < MAX_CONCURRENT_LOADS && waiting.length > 0) {
    activeLoads += 1;
    waiting.shift()();
  }
};

const enqueue = (start) => {
  waiting.push(start);
  startNext();
};

const dequeue = (start) => {
  const index = waiting.indexOf(start);
  if (index !== -1) waiting.splice(index, 1);
};

const releaseSlot = () => {
  activeLoads -= 1;
  startNext();
};

const PreviewThumb = ({ src, alt = "Preview" }) => {
  const [loadSrc, setLoadSrc] = useState(null);
  const releaseRef = useRef(() => {});

  useEffect(() => {
    let state = "waiting"; // waiting -> loading -> done

    const start = () => {
      state = "loading";
      setLoadSrc(src);
    };

    releaseRef.current = () => {
      if (state !== "loading") return;
      state = "done";
      releaseSlot();
    };

    setLoadSrc(null);
    enqueue(start);

    return () => {
      if (state === "waiting") {
        dequeue(start);
        state = "done";
      } else {
        releaseRef.current();
      }
    };
  }, [src]);

  if (!loadSrc) return null;

  return (
    <img
      src={loadSrc}
      alt={alt}
      onLoad={() => releaseRef.current()}
      onError={() => releaseRef.current()}
    />
  );
};

export default PreviewThumb;
